import React from 'react';
import { useClientList } from './api';
import { LoadingState } from '../../components/common/LoadingState';
import { ApiErrorFallback } from '../../components/common/ApiErrorFallback';
import { EmptyState } from '../../components/common/EmptyState';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '../../components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/table';
import { Link } from 'react-router-dom';

export function ClientListPage() {
  const { data, isLoading, error, refetch } = useClientList();

  if (isLoading) {
    return <LoadingState message="Loading clients..." />;
  }

  if (error) {
    return <ApiErrorFallback error={error} onRetry={refetch} />;
  }

  if (!data || data.clients.length === 0) {
    return <EmptyState title="No Clients Found" description="Clients from MindBody will appear here once synced." />;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Clients</CardTitle>
        <CardDescription>A list of all clients in your studio.</CardDescription>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Name</TableHead>
              <TableHead>Email</TableHead>
              <TableHead>Status</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {data.clients.map(client => (
              <TableRow key={client.id}>
                <TableCell>
                  <Link to={`/studio/clients/${client.id}`} className="font-medium text-blue-600 hover:underline">
                    {client.firstName} {client.lastName}
                  </Link>
                </TableCell>
                <TableCell>{client.email}</TableCell>
                <TableCell>{client.isActive ? 'Active' : 'Inactive'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}